var $dd39c57d242c8156$exports = {};
$dd39c57d242c8156$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecione um item`,
    "tableResizer": `Redimensionador`,
    "colorSwatchPicker": `Color swatches`
};


export {$dd39c57d242c8156$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
